import { render, staticRenderFns } from "./AddressEditFields.vue?vue&type=template&id=57fc2eb4&"
import script from "./AddressEditFields.vue?vue&type=script&lang=js&"
export * from "./AddressEditFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports